import vcRadio from './src/vc-radio'

vcRadio.install = function (Vue) {
  Vue.component(vcRadio.name, vcRadio)
}

export default vcRadio
